import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  hide: boolean;
  passwordStrength: number;
  meterMessage: string;
  userID: number;

  constructor(public dialog: MatDialog,
              private cdr: ChangeDetectorRef,
              private dataService: DataService,
              private authService: AuthService,
              public dialogRef: MatDialogRef<ChangePasswordComponent>) {
    this.hide = true;
    this.meterMessage = '';
    this.passwordStrength = 0;
    this.userID = this.authService.getUserData().id;
  }

  ngOnInit(): void {
    this.changePasswordForm = new FormGroup({
      old_password: new FormControl(null, [Validators.required]),
      new_password: new FormControl(null, [Validators.required, Validators.pattern(/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}/)]),
    });
  }
  ngAfterViewChecked(){
    this.cdr.detectChanges();
 }
  onSubmit() {
    if (this.changePasswordForm.valid) {
      const payload = {
        OldPassword: this.changePasswordForm.get('old_password')?.value,
        NewPassword: this.changePasswordForm.get('new_password')?.value,
        UserId: parseInt(this.userID.toString(), 10)
      };
      this.dataService.put('user/UpdateUserPassword', payload).then((data) => {
        if (data.statusCode === 200) {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Success',
              type: 'Success',
              message: 'Password changed successfully',
              buttonText: 'Ok'
            }
          });
        } else if (data.statusCode === 605) {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Old password doesn’t match the current password',
              buttonText: 'Ok'
            }
          });
        }
      });
    } else {
      this.changePasswordForm.markAllAsTouched();
    }
  }

  onStrengthChanged(strength: number) {
    this.passwordStrength = strength;

    console.log(this.passwordStrength);
    switch (strength) {
      case 0:
      case 1:
        this.meterMessage = 'Weak password';
        break;
      case 2:
        this.meterMessage = 'Fair password';
        break;
      case 3:
        this.meterMessage = 'Normal password';
        break;
      case 4:
        this.meterMessage = 'Strong password';
        break;
      default:
        this.meterMessage = '';
        break;
    }
  }

  closeDialog() {
    if (this.changePasswordForm.dirty) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

}
